
import {
  Component,
  Vue, Prop,
} from 'vue-property-decorator';
// @ts-expect-error:
import FeedbackService from '@platform/feedback-service';
import { IUser } from '@/types/user';

@Component({
  components: {},
})
export default class ModalActivate2FA extends Vue {
  @Prop({
    required: true,
    default: () => ({}),
    type: Object,
  }) readonly user!: IUser;

  public agreedTerm = false;

  public loading = false;

  private get url() {
    return `${process.env.VUE_APP_USM_URL}/users/${this.user.id}/require-mfa`;
  }

  public async activate2FA(): Promise<void> {
    this.loading = true;
    try {
      await this.$http.patch(this.url);
      this.$emit('activate2FA');

      FeedbackService.toastr.show('success', this.$t('ACCOUNT.SECURITY.ACTIONS.TOAST_SUCCESS'));
      this.close();
    } catch (error) {
      FeedbackService.toastr.show('danger', this.$t('ACCOUNT.SECURITY.ACTIONS.TOAST_ERROR'));
    } finally {
      this.loading = false;
    }
  }

  public close() {
    this.$emit('onClose2FaModal');
  }
}
